"use strict";

function Debouncer() {
  this.id = null;
  this.node = null;

  this.el = {};

  this._classes = {};

  this.init = function () {};

  this.initAllReady = function () {};

  this._debouncer = function (fn, delay) {
    var t = void 0;
    return function () {
      clearTimeout(t);
      t = setTimeout(fn, delay);
    };
  };
}